import VueI18n from 'vue-i18n'

export const SYSTEM_LABELS = {
  BOT_USER_FLAG_BAN: 1001,
  BOT_USER_FLAG_CUSTOMER: 1002,
  BOT_USER_FLAG_POTENTIAL_CUSTOMER: 1003,
  BOT_USER_FLAG_ADS: 1004,
  BOT_USER_FLAGS_PAID_POST: 1005,
}

export const systemLabelKey = (label: keyof typeof SYSTEM_LABELS) => `${ label.toLowerCase() }_title`

export const systemLabelsRecord = (i18n: VueI18n) => Object.entries(SYSTEM_LABELS)
  .reduce<Record<string, string>>((acc, [ k, v ]) => {
    acc[v] = i18n.t(systemLabelKey(k as keyof typeof SYSTEM_LABELS)).toString()

    return acc
  }, {})
